export default __webpack_public_path__ + "static/media/tree_1.405075cc.png";